/**
 * @description This file has methods to trigger analytic events for content rule center feature
 */

import { ANALYTICS } from '../../constants/common';
import { trackFormInput, trackFormWorkFlow } from './analyticEvents';

/**
 * @method trackRuleCenterInitiate
 * @description this method tracks when the rule center is opened
 * @param {string} userEncodedNtid (user encoded ntid) [user encoded ntid who opened rule center]
 */
export const trackRuleCenterInitiate = (userEncodedNtid: string) => {
  // Track form initiation
  trackFormWorkFlow(
    ANALYTICS.CONTENT_RULE_CENTER_FORM_NAME,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );

  // Track user encoded ntid
  if (userEncodedNtid !== '') {
    trackFormInput(
      ANALYTICS.CONTENT_RULE_CENTER_FORM_NAME,
      ANALYTICS.NUMBER_ONE,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '1'
    );
  }
};
